import React from 'react';

export function InstagramBW() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
      <path
        fill="#15303F"
        fillRule="evenodd"
        d="M15 0H5C2.2 0 0 2.2 0 5v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V5c0-2.8-2.2-5-5-5zm3 15c0 1.7-1.3 3-3 3H5c-1.7 0-3-1.3-3-3V5c0-1.7 1.3-3 3-3h10c1.7 0 3 1.3 3 3v10zM10 5c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm6-8a1 1 0 11-2 0 1 1 0 012 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export function TwitterBW() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" fill="none">
      <path
        fill="#15303F"
        fillRule="evenodd"
        d="M17.953 4.235c.007.184.012.368.012.555C17.965 10.46 13.838 17 6.29 17A11.25 11.25 0 010 15.073a8.004 8.004 0 006.075-1.778c-1.796-.034-3.311-1.275-3.834-2.98a3.962 3.962 0 001.854-.074C2.218 9.847.804 8.112.804 6.034v-.055a3.948 3.948 0 001.859.537C1.56 5.746.836 4.432.836 2.944c0-.787.203-1.524.557-2.158C3.416 3.382 6.44 5.09 9.85 5.27a4.493 4.493 0 01-.106-.978C9.744 1.922 11.58 0 13.846 0c1.181 0 2.248.522 2.995 1.356a7.996 7.996 0 002.607-1.04 4.284 4.284 0 01-1.804 2.373A7.953 7.953 0 0020 2.013a8.576 8.576 0 01-2.047 2.222z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export function FacebookBW() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="21" fill="none">
      <path
        fill="#15303F"
        d="M10.803 10.586H7.66v10.412H3.003V10.586H.789v-3.68h2.214V4.524c0-1.705.871-4.369 4.7-4.369l3.451.013V3.74H8.65c-.408 0-.987.19-.987 1.002v2.163h3.548l-.407 3.68z"
      ></path>
    </svg>
  );
}

export function WhatsappBW() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
      <g fill="#000" clipPath="url(#whatsapp-bw-icon)">
        <path d="M17.758 13.791c-.046-.022-1.796-.884-2.107-.995a1.21 1.21 0 00-.408-.09c-.236 0-.434.117-.589.348-.175.26-.704.879-.867 1.063-.022.025-.05.054-.068.054a6.04 6.04 0 01-.368-.147c-1.877-.815-3.302-2.776-3.497-3.107a.195.195 0 01-.03-.069.546.546 0 01.103-.12c.095-.095.198-.22.298-.34l.141-.167c.145-.17.21-.3.285-.452l.039-.078a.815.815 0 00-.024-.768c-.041-.083-.78-1.866-.859-2.053-.188-.452-.438-.663-.785-.663-.032 0 0 0-.135.006-.164.007-1.06.124-1.455.374-.42.264-1.13 1.108-1.13 2.59 0 1.335.848 2.596 1.211 3.075.01.012.026.037.05.072 1.393 2.034 3.129 3.541 4.889 4.244 1.694.677 2.497.755 2.953.755.192 0 .345-.015.48-.028l.086-.008c.586-.052 1.872-.719 2.165-1.532.23-.64.29-1.34.138-1.594-.105-.173-.287-.26-.516-.37z"></path>
        <path d="M12.213 0C5.713 0 .425 5.248.425 11.7c0 2.086.558 4.128 1.616 5.916L.017 23.588a.312.312 0 00.389.397l6.228-1.979a11.862 11.862 0 005.58 1.392C18.711 23.398 24 18.15 24 11.7 24 5.248 18.712 0 12.213 0zm0 20.96a9.34 9.34 0 01-5.138-1.531.311.311 0 00-.265-.037l-3.12.992 1.007-2.971a.312.312 0 00-.044-.284 9.135 9.135 0 01-1.777-5.43c0-5.107 4.188-9.262 9.337-9.262 5.148 0 9.336 4.155 9.336 9.263 0 5.106-4.188 9.26-9.336 9.26z"></path>
      </g>
      <defs>
        <clipPath id="whatsapp-bw-icon">
          <path fill="#fff" d="M0 0h24v24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export function LinkedinBW() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none">
      <g clipPath="url(#a)">
        <path
          fill="#000"
          d="M13 26c7.18 0 13-5.82 13-13S20.18 0 13 0 0 5.82 0 13s5.82 13 13 13z"
        ></path>
        <path
          fill="#F1F2F2"
          d="M20.767 14.046v5.36H17.66v-5c0-1.256-.449-2.114-1.574-2.114-.858 0-1.369.578-1.594 1.136-.082.2-.103.478-.103.758v5.22h-3.107s.041-8.47 0-9.346h3.107v1.324l-.02.03h.02v-.03c.414-.635 1.15-1.544 2.801-1.544 2.044 0 3.577 1.336 3.577 4.206zM8.031 5.555c-1.063 0-1.759.697-1.759 1.614 0 .897.676 1.615 1.718 1.615h.02c1.084 0 1.758-.718 1.758-1.615-.02-.917-.674-1.614-1.737-1.614zm-1.574 13.85h3.107V10.06H6.457v9.346z"
        ></path>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h26v26H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export function XingBW() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
      <path
        fill="#000"
        d="M5.771 16.817c.368 0 .682-.222.944-.667 2.389-4.237 3.632-6.442 3.729-6.617l-2.38-4.15c-.251-.435-.57-.653-.957-.653H3.639c-.223 0-.378.073-.465.218-.106.145-.101.324.015.537l2.336 4.048c.01.01.01.015 0 .015l-3.671 6.5a.507.507 0 000 .522.485.485 0 00.45.247H5.77zM21.689 0h-3.497c-.377 0-.687.218-.928.653L9.559 14.321l4.918 9.026c.232.435.552.653.958.653h3.468c.213 0 .367-.073.464-.218.097-.165.092-.344-.014-.537l-4.875-8.924v-.014L22.139.755c.106-.203.106-.382 0-.537-.087-.145-.237-.218-.45-.218z"
      ></path>
    </svg>
  );
}

export function YoutubeBW() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
      <g clipPath="url(#a)">
        <path
          fill="#000"
          d="M23.506 6.239a3.007 3.007 0 00-2.116-2.116C19.512 3.61 12 3.61 12 3.61s-7.512 0-9.39.495A3.068 3.068 0 00.493 6.239C0 8.117 0 12.01 0 12.01s0 3.915.494 5.773a3.008 3.008 0 002.116 2.115c1.897.514 9.39.514 9.39.514s7.512 0 9.39-.494a3.007 3.007 0 002.116-2.115C24 15.926 24 12.03 24 12.03s.02-3.914-.494-5.792z"
        ></path>
        <path
          fill="#fff"
          d="M9.607 15.61l6.247-3.598-6.247-3.598v7.196z"
        ></path>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h24v24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export function PinterestBW() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
      <g clipPath="url(#a)">
        <path
          fill="#000"
          d="M12.01 0C5.388 0 .02 5.368.02 11.99c0 5.082 3.157 9.425 7.618 11.171-.109-.947-.197-2.408.04-3.444.217-.937 1.4-5.96 1.4-5.96s-.355-.72-.355-1.777c0-1.668.968-2.91 2.171-2.91 1.027 0 1.52.769 1.52 1.687 0 1.026-.651 2.565-.996 3.996-.287 1.194.602 2.171 1.776 2.171 2.131 0 3.77-2.25 3.77-5.486 0-2.872-2.063-4.876-5.013-4.876-3.415 0-5.418 2.556-5.418 5.201 0 1.027.394 2.132.888 2.734a.357.357 0 01.079.345c-.089.375-.296 1.194-.336 1.362-.05.217-.177.266-.404.158-1.5-.7-2.438-2.882-2.438-4.648 0-3.78 2.744-7.254 7.924-7.254 4.155 0 7.392 2.961 7.392 6.928 0 4.135-2.605 7.46-6.217 7.46-1.214 0-2.359-.631-2.744-1.381l-.75 2.852c-.266 1.046-.996 2.349-1.49 3.148A12.06 12.06 0 0011.99 24c6.622 0 11.99-5.369 11.99-11.99C24 5.368 18.631 0 12.01 0z"
        ></path>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h24v24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}
